const SYNCEE_ROUTE_PREFIX = "/dropshipping/syncee";
const SYNCEE_PAGES = Object.freeze([
  "DropshippingPlatforms", "DropshippingPlatformDetails", "DropshippingSynceeConnect",
  "DropshippingSuppliers", "DropshippingSupplierProducts", "DropshippingAllProducts",
  "DropshippingProductDetails", "DropshippingImportedProducts", "DropshippingOrders",
  "DropshippingApiErrors", "DropshippingAdmin",
]);
module.exports = { SYNCEE_ROUTE_PREFIX, SYNCEE_PAGES };
